import { PAGE_SIZES, type PageSize } from "@/components/Pagination";

export type PageSearch = { page?: number; page_size?: PageSize };

const whole = (value: unknown) => (typeof value === "string" && /^\d+$/.test(value) ? Number(value) : value);

/** page and page_size from the URL; anything else is dropped. */
export const pageSearch = (search: Record<string, unknown>): PageSearch => {
  const page = whole(search.page);
  const size = whole(search.page_size);
  return {
    page: typeof page === "number" && Number.isSafeInteger(page) && page >= 1 ? page : undefined,
    page_size: PAGE_SIZES.find((s) => s === size),
  };
};

/** The list call's paging params, sent only when the URL names them. */
export const pageParams = ({ page, page_size }: PageSearch) => ({
  ...(page ? { page } : {}),
  ...(page_size ? { pageSize: page_size } : {}),
});
